import OLFormatGeoJSON from 'ol/format/GeoJSON'
import { all as OLLoadingStrategyAll } from 'ol/loadingstrategy'
import OLSourceVector from 'ol/source/Vector'

export default function () {
  return new OLSourceVector({
    format: new OLFormatGeoJSON(),
    crossOrigin: 'Anonymous',
    strategy: OLLoadingStrategyAll,
    projection: 'EPSG:3857'
  })
}
